module.exports = "https://cdn.hellotech.com/client-assets/networking-desktop_455398c86d523379766589a8bebdbad6.jpg";